export const Dashboard = () => {
    return <p>This is dashboard page.</p>
}